export const PERMS = {
    READ: 'blocked_ips.read',
    UPDATE: 'blocked_ips.update',
    DELETE: 'blocked_ips.delete',
    CREATE: 'blocked_ips.create',
    EXPORT: 'blocked_ips.export',
}
